import type { UppyFile } from "@uppy/core"
import type { UppyBody, UppyMeta } from "@/composables/useUppy"
import type { ServerResponseV1 } from "@/http"
import { v1 } from "@/axios"

interface PresignedUrlResponse {
  uploadUrl: string
  key: string
  fileName: string
}

export async function getPresignedUrl(file: UppyFile<UppyMeta, UppyBody>, eventVaultId: number, albumId?: number) {
  const response = await v1.post<ServerResponseV1<PresignedUrlResponse>>(
    `/upload/${eventVaultId}/presigned`,
    {
      fileName: file.name,
      contentType: file.type || "application/octet-stream",
      fileSize: file.size,
      eventVaultId,
      albumId,
    },
  )

  return response.data
}
